import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  class: "mosta-checkbox__icon",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = {
  key: 0,
  class: "mosta-checkbox__check",
  d: "M13 5L6.125 12L3 8.81818",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_3 = {
  key: 0,
  class: "mosta-checkbox__label"
}

import { computed } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'MostaCheckbox',
  props: {
    modelValue: { default: false },
    label: {},
    disable: { type: Boolean, default: false },
    trueValue: { default: true },
    falseValue: { default: false },
    toggleIndeterminate: { type: Boolean, default: false },
    indeterminateValue: { default: null }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const isChecked = computed(() => props.modelValue === props.trueValue);

const isIndeterminate = computed(() =>
  props.toggleIndeterminate && props.modelValue === props.indeterminateValue
);

function toggle() {
  if (props.disable) return;

  if (props.toggleIndeterminate) {
    if (props.modelValue === props.falseValue) {
      emitValue(props.indeterminateValue);
    } else if (props.modelValue === props.indeterminateValue) {
      emitValue(props.trueValue);
    } else {
      emitValue(props.falseValue);
    }
  } else {
    emitValue(isChecked.value ? props.falseValue : props.trueValue);
  }
}

function emitValue(val: any) {
  emit('update:modelValue', val);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("label", {
    class: _normalizeClass(["mosta-checkbox", {
      'mosta-checkbox--disabled': _ctx.disable,
      'mosta-checkbox--checked': isChecked.value,
    }]),
    onClick: _withModifiers(toggle, ["prevent"])
  }, [
    (_openBlock(), _createElementBlock("svg", _hoisted_1, [
      _cache[0] || (_cache[0] = _createElementVNode("rect", {
        class: "mosta-checkbox__box",
        x: "0.5",
        y: "0.5",
        width: "15",
        height: "15",
        rx: "3.5",
        fill: "white"
      }, null, -1)),
      (isChecked.value)
        ? (_openBlock(), _createElementBlock("path", _hoisted_2))
        : _createCommentVNode("", true)
    ])),
    (_ctx.label)
      ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.label), 1))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})